import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'fi-checkpoint-edit-actions-description',
    template: `
        <mat-card class="fi-rounded-card fi-checkpoint-edit-tab-description-card">
            <mat-card-content>
                <div>
                    <mat-card-title class="checklist-card-title">{{
                        'checklist.checkpoint_automated_actions' | fiAppText
                    }}</mat-card-title>
                    <p
                        class="checkpoint-card-text"
                        [innerHTML]="'checklist.checkpoint_automated_actions_description' | fiAppText"
                    ></p>
                </div>
            </mat-card-content>
        </mat-card>
    `,
    styleUrls: ['./actions-description.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-checkpoint-edit-actions-description' },
    standalone: false,
})
export class FiCheckpointEditActionsDescriptionComponent implements OnInit {
    constructor() {}

    ngOnInit(): void {}
}
